export const formatPoints = (value) => {
  const num = Number(value);

  if (Number.isNaN(num)) return "0";

  return Math.round(num).toLocaleString();
};

export const formatSignedPoints = (value) => {
  const num = Number(value);

  if (Number.isNaN(num) || num === 0) return "0";

  const sign = num > 0 ? "+" : "-";

  return `${sign}${formatPoints(Math.abs(num))}`;
};
